// @flow

import wx from '@caofeilong/weixin_js'

type ShareInfo = {
  title: string,
  path: string,
  imageUrl: string
};

export function setPageTitle (title: string) {
  if (title) {
    document.getElementsByTagName('title')[0].innerHTML = title
  }
}

export function toPageRouter (path: string, replace?: boolean) {
  if (/^https?:\/\/.*$/.test(path)) {
    path = `/pages/web/index?src=${encodeURIComponent(path)}`
  }
  (replace ? wx.miniProgram.redirectTo : wx.miniProgram.navigateTo)({
    url: path
  })
}

export function historyBack (delta: number = 1) {
  wx.miniProgram.navigateBack({ delta })
}

export function shareWeixinApp (shareInfo: ShareInfo) {
  if (!shareInfo) {
    return
  }
  wx.miniProgram.postMessage({
    data: {
      fun: 'share',
      params: shareInfo
    }
  })
}

export function postMessage (data: any) {
  wx.miniProgram.postMessage({
    data
  })
}



// WEBPACK FOOTER //
// ./src/frame/core/app/weixin.js